"use client";

function Button({ text, style, href = "#", handleClick, external = true }: any) {
  const handleButtonClick = (e: any) => {
    if (handleClick) {
      e.preventDefault(); // Prevent link navigation if handleClick is provided
      handleClick();
    }
  };
  return (
    <a href={href} {...(external ? { target: "_blank", rel: "noopener" } : {})} className={`${style.includes("w-full") ? "w-full" : "w-fit"}`}>
      <button
        className={`flex font-poppins justify-center items-center text-center px-8 py-3 rounded font-medium text-xs xl:text-sm whitespace-nowrap shadow ${style} ${style.includes("w-full") ? "w-full" : "w-fit"}`}
        onClick={handleButtonClick}
      >
        <div className="flex justify-center items-center w-full">
          <span className="font-semibold text-center w-full">{text}</span>
        </div>
      </button>
    </a>

  );
}

export default Button;
